import PromoTileWrapper from "../PromoTileWrapper";
import PropTypes from "prop-types";
import styles from "./PromoTile.css";

const config = {
  COM: {
    translations: {
      asos_students: "asos students",
      get_10_off: "GET 10% OFF",
      copy:
        "Sign up now and get 10% off until you graduate. It's an unmissable deal!",
      sign_up: "SIGN UP",
      tnc: "Ts&Cs apply."
    },
    linkUrl:
      "https://www.asos.com/discover/students/asos-on-campus/student-validation/#ctaref-plp-tile"
  },
  US: {
    translations: {
      asos_students: "asos students",
      get_10_off: "GET 10% OFF",
      copy:
        "Sign up now and get 10% off until you graduate. It's an unmissable deal!",
      sign_up: "SIGN UP",
      tnc: "Ts&Cs apply."
    },
    linkUrl:
      "https://www.asos.com/us/discover/students/asos-on-campus/student-validation/#ctaref-plp-tile"
  },
  FR: {
    translations: {
      asos_students: "asos étudiants",
      get_10_off: "-10 % POUR TOI",
      copy:
        "-10 % POUR TOI Inscris-toi et profite de -10 % jusqu'à la fin de tes études.",
      sign_up: "JE SIGNE",
      tnc: "Voir conditions."
    },
    linkUrl:
      "https://www.asos.com/fr/decouvrez/students/asos-on-campus/student-validation/#ctaref-plp-tile"
  },
  DE: {
    translations: {
      asos_students: "asos studis",
      get_10_off: "10% RABATT FÜR STUDIS",
      copy:
        "HOL DIR -10% Registriere dich jetzt und erhalte -10% bis zu deinem Uniabschluss!",
      sign_up: "REGISTRIEREN",
      tnc: "Es gelten die AGB."
    },
    linkUrl:
      "https://www.asos.com/de/entdecken/students/asos-on-campus/student-validation/#ctaref-plp-tile"
  }
};

const PromoTile = ({ storeCode }) => {
  const {
    translations: { asos_students, get_10_off, copy, sign_up, tnc },
    linkUrl
  } = config[storeCode];

  return (
    <PromoTileWrapper linkUrl={linkUrl}>
      <div className={styles.promoTile}>
        <div className={styles.asos_students}>{asos_students}</div>
        <div className={styles.get_10_off}>{get_10_off}</div>
        <div className={styles.copy}>{copy}</div>
        <div className={styles.sign_up_wrapper}>
          <div className={styles.sign_up}>{sign_up}</div>
          <div className={styles.tnc}>{tnc}</div>
        </div>
      </div>
    </PromoTileWrapper>
  );
};

PromoTile.propTypes = {
  storeCode: PropTypes.string.isRequired
};

export default PromoTile;
